import SocketAPI from "./socket";
import {pushNotification} from "../../../data/actions/ui";
import {addNotification, errorGetNotificationList, notificationsConnected, notificationsConnecting} from "./actions/notifications";
import {getProp} from "../../util/util-helpers";
import LocalStorage from "../../util/localStorage";

const socket = new SocketAPI();

const OnNotificationEvent = "OnNotification";

const notificationMiddleware = store => next => action => {
    switch (action.type) {
        case 'DONE_LOGIN':
            connect(socket, store)
            break;
        case 'LOGOUT':
            disconnect(socket, store)
            break;
        default:
            break;
    }

    return next(action);
};

notificationMiddleware.getUrl = () => {
    return null;
}

notificationMiddleware.getToken = () => {
    return null;
}

notificationMiddleware.getCurrentUser = () => {
    return LocalStorage.get('user');
}

notificationMiddleware.run = (store, getUrl, getToken) => {
    notificationMiddleware.getUrl = getUrl;
    notificationMiddleware.getToken = getToken;

    if (getToken()) {
        connect(socket, store)
    }
}

const connect = (socket, store) => {
    const currentUser = notificationMiddleware.getCurrentUser();
    if (socket?.socket?.connected) {
        store.dispatch(notificationsConnected());
        return;
    }

    store.dispatch(notificationsConnecting());

    socket.connect(notificationMiddleware.getUrl(), notificationMiddleware.getToken())
        .then(() => {
            console.log("notificationMiddleware:connect")
            store.dispatch(notificationsConnected());
        })
        .catch((e) => {
            console.log("notificationMiddleware:error", e)
            store.dispatch(errorGetNotificationList(e));
        });

    // "OnNotifications" (plural, full-list sync) is deliberately not handled here
    // anymore - nothing in either backend emits it, and Phase 2 gives the bell its
    // real "get my history" mechanism via a REST fetch instead (see
    // notificationSyncSaga.jsx, triggered on DONE_LOGIN). This handler now only
    // covers live incremental pushes for an already-open session.
    socket.on(OnNotificationEvent, (data) => {
        if (!!data.Metadata && (data.Metadata?.event === "silent")) {
            store.dispatch(pushNotification({
                    user: currentUser,
                    title: data.Title,
                    content: data.Message,
                    notificationMetadata: data.Metadata,
                    position: "silent",
                    messageType: data.Metadata.messageType ?? 'success'
                }
            ));
        } else {
            store.dispatch(pushNotification({
                    user: currentUser,
                    title: data.Title,
                    content: data.Message,
                    notificationMetadata: data.Metadata,
                    position: "top",
                    messageType: data.Metadata.messageType ?? 'success'
                }
            ));

            let unreadCount = store.getState()?.notifications?.data?.unreadCount ?? 0;
            let totalCount = store.getState()?.notifications?.data?.totalCount ?? 0;
            let notifications = store.getState()?.notifications?.data?.notifications ?? {
                list: [],
                count: 0
            };
            unreadCount += 1;
            totalCount += 1;
            notifications.list.push({...data, IsRead: false});
            store.dispatch(addNotification({
                unreadCount: unreadCount,
                totalCount: totalCount,
                notifications: notifications
            }));

            void playAudioNotification(currentUser);
        }
    });
}

async function playAudioNotification(currentUser) {
    const href = getProp(currentUser, 'Contact.NotificationSound', 0)
    if (href && !getProp(currentUser, 'Contact.NotificationSoundMute', 1)) {
        const audio = new Audio(`/audio/${href}.mp3`);

        if (audio.paused || audio.ended) {
            const playPromise = audio.play();

            if (playPromise !== undefined) {
                playPromise.catch((error) => {
                    console.error('Error while trying to play media:', error);
                });
            }
        }
    }
}

const disconnect = (socket) => {
    socket.disconnect()
        .then(() => {
            console.log("notificationMiddleware:disconnect");
        })
        .catch((e) => {
            console.log("notificationMiddleware:error", e)
        });
}

export default notificationMiddleware
